<template>
  <div>
    <base-form :title="title || $t('generic.details')" @submit="submitForm">
      <div class="row d-flex" v-if="user">
        <div class="px-4">
          <image-upload @on-change="onImageChange"
                        :src="$avatar.generate(user)">
          </image-upload>
        </div>
        <div class="col-12 col-sm-8 col-md-7 col-xl-8">
          <div class="row">
            <div class="col-12">
              <base-radio inline v-model="userToEdit.salutation" label="MR">Mr</base-radio>
              <base-radio inline v-model="userToEdit.salutation" label="MISS">Miss</base-radio>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <fg-input :placeholder="$t('user.details.edit.givenName')"
                        :name="$t('user.details.edit.givenName')"
                        :error="getError($t('user.details.edit.givenName'))"
                        :label="$t('user.details.edit.givenName')"
                        v-validate="modelValidations.given_name"
                        v-model="userToEdit.given_name">
              </fg-input>
            </div>
            <div class="col-12">
              <fg-input :placeholder="$t('user.details.edit.familyName')"
                        :name="$t('user.details.edit.familyName')"
                        :error="getError($t('user.details.edit.familyName'))"
                        :label="$t('user.details.edit.familyName')"
                        v-validate="modelValidations.family_name"
                        v-model="userToEdit.family_name">
              </fg-input>
            </div>
          </div>
          <modal :show.sync="showPasswordResetModal">
            <h6 slot="header" class="text-success">
              {{$t('user.details.edit.passwordResetSuccess')}}
            </h6>
            <div>
              {{$t('user.details.edit.newPassword')}}: <b>{{newPassword}}</b>
              <base-button v-clipboard:copy="newPassword"
                           class="ml-2"
                           type="info"
                           size="sm"
                           outline>
                {{$t('generic.copy')}}
              </base-button>
            </div>
          </modal>
        </div>
      </div>
      <template v-slot:footer>
        <submit-button v-if="canResetPassword" class="mr-2" outline @click="changePassword">
          {{$t('user.details.edit.resetPassword')}}
        </submit-button>
        <submit-button native-type="submit"/>
      </template>
    </base-form>
    <slot name="after-form"></slot>
    <addresses-list :id="user.uuid ||$route.params.id" primary-entity="user"/>

    <phone-list :id="user.uuid ||$route.params.id" primary-entity="user"/>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import AdminService from 'src/services/AdminService'
  import { Select, Option } from 'element-ui'
  import ImageUpload from 'src/components/ImageUpload'
  import AddressesList from 'src/views/admin/contacts/common/AddressesList'
  import PhoneList from 'src/views/admin/contacts/common/PhonesList'

  Vue.use(VueClipboard)
  export default {
    name: 'user-details-edit-card',
    components: {
      PhoneList,
      ImageUpload,
      AddressesList,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      user: {
        type: Object,
        default: () => ({})
      },
      canResetPassword: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        userToEdit: {},
        newPassword: '',
        showPasswordResetModal: false,
      }
    },
    computed: {
      modelValidations () {
        return {
          given_name: {
            required: true,
            min: 2
          },
          family_name: {
            required: true,
            min: 2
          },
        }
      }
    },
    methods: {
      async changePassword () {
        await this.$confirm(this.$t('user.details.edit.confirm.title'), {
          title: this.$t('user.details.edit.confirm.title'),
          message: this.$t('user.details.edit.confirm.message')
        })
        try {
          let {data} = await AdminService.resetUserPassword(this.user.email)
          this.showPasswordResetModal = true
          this.newPassword = data.password
        } catch (e) {
          console.warn(e)
        }
      },
      onUserChange (newVal) {
        if (!newVal) {
          return
        }
        this.userToEdit = JSON.parse(JSON.stringify(newVal))
      },
      onImageChange (src) {
        this.userToEdit.image = src
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async validate () {
        return this.$validator.validateAll()
      },
      async submitForm () {
        let result = await this.validate()
        if (!result) return
        this.$emit('submit', this.userToEdit.uuid, {...this.userToEdit})
      }
    },
    created () {
      this.$watch('user', this.onUserChange, {immediate: true})
    }
  }
</script>
<style>
</style>
